import React from 'react';

const Performance = () => {
  return (
      <div className="section" id="performance">
        <h2>Performance</h2>
      <div className="list-container">
        <div className="card">
          <h3>Equipment</h3>
          <ul>
            <li>Athletic Works (10lb pair) Ankle and Wrist weights</li>
            <li>Dumbbells (10lb, 15lb, and 25lb)</li>
            <li>Gunner Blue Light Glasses (Cruz Amber blocks 65% blue light)</li>
            <li>Gymnastics Power (25lb) Weight Vest</li>
            <li>Hapbear Model HB-AB04 Resistance Bands</li>
            <li>Hydrow Pro Rower</li>
            <li>Kettle Bell (1 x 30lb)</li>
            <li>LoGest Hand Grips (4 Pack 50-200lb)</li>
            <li>Major Fitness F22 Multi-Functional Power Rack</li>
            <li>Squat Wedge Block One Piece</li>
            <li>Sole E25 Elliptical</li>
            <li>Viva Barefoot shoes (I had significant issues with twisting one of my ankles and after 6 months of using these daily the problem was resolved)</li>
          </ul>
        </div>
        <div className="card">
          <h3>Diagnostics</h3>
          <ul>
            <li>Apple Watch</li>
            <li>Etekcity Smart Fitness Scale</li>
            <li>Dexcom G7 CGM</li>
            <li>Handexer Digital Hand Dynamometer (Tests grip strength)</li>
            <li>Levels Food Tracking</li>
            <li>Lifeextension - LC100086 Cardio Core Essentials Panel (This test was how I found my ApoB was High)</li>
            <li>Lifeextension - LC100016 Male Elite Panel (This test is how I found my DHEA was Low)</li>
            <li>Lifeextension - LC001800 Zinc/Serum</li>
            <li>Lifeextension - LC123283 Plac Test for LP-PLA2</li>
            <li>Lifeextension - LC100034 Oxidized LDL Panel</li>
            <li>Lifeextension - LC120188 LP(A)</li>
            <li>Lifeextension - LC100003 Heavy Metals Panel</li>
            <li>Lifeextension - LC120251 COQ10 (COENZYME Q10)</li>
            <li>Nebula Genomics full DNA 30x scan</li>
            <li>Urinox-10 Reagent Strips (I learned when my body goes into Ketosis using this item)</li>
            <li>Viome Full Body Intelligence (Major changes to food based on this test)</li>
            <li>Whoop</li>
          </ul>
        </div>
      </div>
      </div>
  );
};

export default Performance;